import React from "react";
import { Link } from "react-router-dom";

export const GoldBtn = ({ onClick, to, children, testid, className = "", type = "button" }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-sm bg-gold px-8 py-4 text-base font-bold uppercase tracking-wider text-ink transition-colors hover:bg-goldhi disabled:opacity-70 ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
  return <button type={type} onClick={onClick} className={cls} data-testid={testid}>{children}</button>;
};

export const OutlineBtn = ({ to, onClick, children, testid, className = "", type = "button" }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-sm border border-gold/50 px-8 py-4 text-base font-semibold uppercase tracking-wider text-gold transition-colors hover:bg-gold/10 hover:border-gold ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testid}>{children}</Link>;
  return <button type={type} onClick={onClick} className={cls} data-testid={testid}>{children}</button>;
};

export const PageHero = ({ kicker, title, subtitle, image }) => (
  <section className="relative grain overflow-hidden pt-40 pb-20 sm:pb-28 border-b border-gold/15" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover object-top opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/85 to-ink" />
      </>
    )}
    <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
      {kicker && <div className="kicker mb-5">{kicker}</div>}
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light leading-[0.98] tracking-tight text-ivory">{title}</h1>
      {subtitle && <p className="mt-6 max-w-2xl text-lg sm:text-xl leading-relaxed text-ivory2">{subtitle}</p>}
    </div>
  </section>
);
